<template>
  <div class="card">
    <Toolbar class="p-mb-4">
      <template #start>
        <Button
          label="Novo"
          icon="pi pi-plus"
          class="mr-2"
          @click="showCreate()"
        />
      </template>
      <template #end>
        <div
          class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between"
        >
          <span class="p-input-icon-left">
            <i class="pi pi-search" />
            <InputText
              v-model="filters['global'].value"
              placeholder="Buscar..."
            />
          </span>
        </div>
      </template>
    </Toolbar>

    <DataTable
      ref="dt1"
      dataKey="id"
      class="p-datatable-sm"
      :value="allSubUnidade"
      :paginator="true"
      :rows="10"
      :filters="filters"
      :rowsPerPageOptions="[10, 15, 20]"
      paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
      currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} setores."
    >
      <template #empty>
        <div class="text-center">Nenhum resultado encontrado...</div>
      </template>
      <Column header="Nome do Setor" field="descricao" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.descricao }}
        </template>
      </Column>
      <Column
        header="Unidade Pertencente"
        field="unidade.descricao"
        :sortable="true"
      >
        <template #body="slotProps">
          {{ slotProps.data.unidade.descricao }}
        </template>
      </Column>
      <Column header="Ações">
        <template #body="slotProps">
          <Button
            icon="pi pi-pencil"
            class="p-button-rounded p-button-success mr-2"
            @click="showUpdate(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EDITAR'"
          />
          <Button
            icon="pi pi-trash"
            class="p-button-rounded p-button-warning"
            @click="showRemove(slotProps.data)"
            v-tooltip.top="'CLIQUE PARA EXCLUIR'"
          />
        </template>
      </Column>
    </DataTable>
  </div>
  <ConfirmDialog></ConfirmDialog>
  <dialog-form :selected="subUnidade" @findAll="findAll()" />
</template>

<script>
import { FilterMatchMode } from "primevue/api";

//models
import SubUnidade from "../../models/subUnidade";

//Services
import SubUnidadeService from "../../service/subUnidade/subUnidadeService";

//components
import DialogForm from "./components/dialog-form.vue";

export default {
  components: {
    DialogForm,
  },
  data() {
    return {
      filters: {},
      allSubUnidade: [],
      subUnidade: new SubUnidade(),
      subUnidadeService: new SubUnidadeService(),
      loading: false,
    };
  },
  created() {
    this.initFilters();
  },
  mounted() {
    this.findAll();
  },
  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    showCreate() {
      this.subUnidade = new SubUnidade();
      this.$store.state.views.setores.dialogForm = true;
    },
    showUpdate(data) {
      this.subUnidade = { ...data };
      this.$store.state.views.setores.dialogForm = true;
    },
    showRemove(data) {
      this.subUnidade = data;
      this.$confirm.require({
        message: "Deseja excluir esse setor?",
        header: "Deseja deletar?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.subUnidadeService
            .delete(this.subUnidade.id)
            .then((data) => {
              this.$msgSuccess(data);
              this.findAll();
            })
            .catch((err) => {
              this.loading = false;
              this.$toast.add({
                severity: "error",
                summary: "Alerta de Erro.",
                detail: err,
                life: 6000,
              });
            });
        },
      });
    },
    findAll() {
      this.subUnidadeService.findAll().then((data) => {
        this.allSubUnidade = data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
